var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevokeAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15191_25406",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08301 2.08268H17.9163V17.916H2.08301V2.08268Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15191_25406)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43915 15.9827C6.49479 16.927 4.96367 16.9271 4.01928 15.9827C3.07491 15.0383 3.07491 13.5071 4.01928 12.5628L6.59097 9.99108C6.83018 9.75187 6.83018 9.36404 6.59097 9.12483C6.35176 8.88562 5.96392 8.88562 5.72472 9.12483L3.15302 11.6965C1.73024 13.1193 1.73024 15.4261 3.15302 16.8489C4.57583 18.2717 6.88262 18.2717 8.30541 16.8489C8.30541 16.8489 8.30541 16.8489 8.30541 16.8489L10.8771 14.2772C11.1163 14.038 11.1163 13.6502 10.8771 13.411C10.6379 13.1718 10.2501 13.1718 10.0108 13.411L7.43916 15.9827L7.43915 15.9827Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4109 10.8733C13.6501 11.1125 14.0379 11.1125 14.2771 10.8733L16.8488 8.30164C18.2716 6.87885 18.2716 4.57203 16.8488 3.14925C15.426 1.72644 13.1192 1.72643 11.6964 3.14925C11.6964 3.14925 11.6964 3.14926 11.6964 3.14926L9.12472 5.72094C8.88551 5.96015 8.88551 6.34799 9.12472 6.5872C9.36393 6.8264 9.75176 6.8264 9.99097 6.5872L12.5627 4.0155L12.5627 4.0155C13.507 3.07111 15.0381 3.07111 15.9825 4.0155C16.9269 4.95987 16.9269 6.49102 15.9825 7.43538L13.4109 10.0071C13.1716 10.2463 13.1716 10.6341 13.4109 10.8733Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65769 5.65653C5.8969 5.41732 5.8969 5.02949 5.65769 4.79028L4.37183 3.50442C4.13262 3.26521 3.74479 3.26521 3.50558 3.50442C3.26637 3.74363 3.26637 4.13146 3.50558 4.37067L4.79144 5.65653C5.03065 5.89574 5.41848 5.89574 5.65769 5.65653Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65769 5.65653C5.8969 5.41732 5.8969 5.02949 5.65769 4.79028L4.37183 3.50442C4.13262 3.26521 3.74479 3.26521 3.50558 3.50442C3.26637 3.74363 3.26637 4.13146 3.50558 4.37067L4.79144 5.65653C5.03065 5.89574 5.41848 5.89574 5.65769 5.65653Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08301 6.93825C2.08301 7.27654 2.35725 7.55078 2.69554 7.55078H4.514C4.85229 7.55078 5.12653 7.27654 5.12653 6.93825C5.12653 6.59996 4.85229 6.32572 4.514 6.32572H2.69554C2.35725 6.32572 2.08301 6.59996 2.08301 6.93825Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08301 6.93825C2.08301 7.27654 2.35725 7.55078 2.69554 7.55078H4.514C4.85229 7.55078 5.12653 7.27654 5.12653 6.93825C5.12653 6.59996 4.85229 6.32572 4.514 6.32572H2.69554C2.35725 6.32572 2.08301 6.59996 2.08301 6.93825Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9387 5.12695C7.277 5.12695 7.55124 4.85271 7.55124 4.51442V2.69596C7.55124 2.35767 7.277 2.08343 6.9387 2.08343C6.60041 2.08343 6.32617 2.35767 6.32617 2.69596V4.51442C6.32617 4.85271 6.60041 5.12695 6.9387 5.12695Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9387 5.12695C7.277 5.12695 7.55124 4.85271 7.55124 4.51442V2.69596C7.55124 2.35767 7.277 2.08343 6.9387 2.08343C6.60041 2.08343 6.32617 2.35767 6.32617 2.69596V4.51442C6.32617 4.85271 6.60041 5.12695 6.9387 5.12695Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4946 16.4944C16.7338 16.2552 16.7338 15.8674 16.4946 15.6282L15.2087 14.3423C14.9695 14.1031 14.5817 14.1031 14.3425 14.3423C14.1033 14.5815 14.1033 14.9694 14.3425 15.2086L15.6284 16.4944C15.8676 16.7336 16.2554 16.7336 16.4946 16.4944Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4946 16.4944C16.7338 16.2552 16.7338 15.8674 16.4946 15.6282L15.2087 14.3423C14.9695 14.1031 14.5817 14.1031 14.3425 14.3423C14.1033 14.5815 14.1033 14.9694 14.3425 15.2086L15.6284 16.4944C15.8676 16.7336 16.2554 16.7336 16.4946 16.4944Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0608 17.916C13.3991 17.916 13.6733 17.6418 13.6733 17.3035V15.485C13.6733 15.1467 13.3991 14.8725 13.0608 14.8725C12.7225 14.8725 12.4482 15.1467 12.4482 15.485V17.3035C12.4482 17.6418 12.7225 17.916 13.0608 17.916Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0608 17.916C13.3991 17.916 13.6733 17.6418 13.6733 17.3035V15.485C13.6733 15.1467 13.3991 14.8725 13.0608 14.8725C12.7225 14.8725 12.4482 15.1467 12.4482 15.485V17.3035C12.4482 17.6418 12.7225 17.916 13.0608 17.916Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.873 13.0613C14.873 13.3996 15.1473 13.6738 15.4856 13.6738H17.304C17.6423 13.6738 17.9166 13.3996 17.9166 13.0613C17.9166 12.723 17.6423 12.4488 17.304 12.4488H15.4856C15.1473 12.4488 14.873 12.723 14.873 13.0613Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.873 13.0613C14.873 13.3996 15.1473 13.6738 15.4856 13.6738H17.304C17.6423 13.6738 17.9166 13.3996 17.9166 13.0613C17.9166 12.723 17.6423 12.4488 17.304 12.4488H15.4856C15.1473 12.4488 14.873 12.723 14.873 13.0613Z",
    fill: "#F04438"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevokeAccess);
export default __webpack_public_path__ + "static/media/revoke-access.3cfcb62131e9921745f6aacfe37b7ae2.svg";
export { ForwardRef as ReactComponent };